import React from 'react'

const Hero = () => {
  return (
    <section className="hero">
      <video autoPlay muted loop playsInline className="video-bg">
        <source src="images/video-trator.mp4" type="video/mp4" />
        Seu navegador não suporta vídeos.
      </video>

      <div className="overlay"></div>

      <div className="hero-content">
        <h1>Tecnologia para o campo com Precisão</h1>
        <p>
          Especialistas em reparos e soluções tecnológicas para agricultura de
          precisão.
        </p>
        <p>Atendimento no campo e laboratório especializado.</p>
        <a href="https://wa.me/5567981414278" className="btn">
          <i className="fab fa-whatsapp"></i> Agendar Atendimento
        </a>
      </div>
    </section>
  )
}

export default Hero
